import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 14 14",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.17038 1.16669H4.82949L4.24616 2.91669H1.16663V4.08335H2.33329V12.8334H11.6666V4.08335H12.8333V2.91669H9.75371L9.17038 1.16669ZM8.52393 2.91669L8.32949 2.33335H5.67037L5.47593 2.91669H8.52393ZM3.49996 4.08335H10.5V11.6667H3.49996V4.08335Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.25 10.5V5.25H6.41667V10.5H5.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.58337 10.5V5.25H8.75004V10.5H7.58337Z",
			fill: "currentColor"
		})
	]
});
export default SvgTrash;
